import React, {useRef, useState} from "react";
import Tabs from "../../layouts/Tabs";
import {Button, Row, Col, Modal, Badge, OverlayTrigger, Tooltip, Spinner} from "react-bootstrap";
import Dropdown from "../../primer/Dropdown";
import {
    checkPermission,
    companyYearOptions,
    escapeRegex,
    expandSearch,
    getCurrentUser,
    isEmpty
} from "../../../_helpers/commonFunctions";
import "./index.css";
import Input from "../../common/Input";
import {useDispatch, useSelector} from "react-redux";
import {setCompany} from "../../../_reducers/companySlice";
import {useEffect} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import {logout} from "../../../_reducers/Login";
import {
    fetchPrimerMyDataCredentials
} from "../../../_apis/api";
import CallCenterLive from "../data-panel/CRM/callcenter-live";
import moment from "moment";
import {setUpgradeEmployeeLimitModalData} from "../../../_reducers/DataPanel/Payroll/payrollSlice";
import EmronClientData from "./emronClientData";
import AdvancedCombobox from "../../primer/AdvancedCombobox";
import {setShowFooterDrawer, setShowPrimerMyDataToExpireModal} from "../../../_reducers/activitySlice";
import DrugInfoModal from "../data-panel/Prescriptions/Components/drugInfoModal";
import {FaChevronDown, FaChevronUp} from "react-icons/fa";
import DialUp from "../data-panel/CRM/dial-up";
import {setShowNewBankAgreementAttentionModal, setTaxisScrapingState} from "../../../_reducers/DataPanel/Accounting/accountingSlice";
import useMediaQuery from "../../../hooks/useMediaQuery";
import {openCloud, openTabByType} from "../../../_helpers/tabOpeners";
import {useTranslation} from "../../../hooks/useTranslation";
import ReleaseNotesModal from "../../primer/POPUP-COMPONENTS/ReleaseNotesModal";

const apiLoginURL = process.env.REACT_APP_LOGIN_URL;
const errorAuth = "You are not Authorized!";

const ViewWrapper = ({permissionsData}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const [companyData, setCompanyData] = useState([]);
    const [companyFilterInput, setCompanyFilterInput] = useState("");
    const [show, setShow] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [tableData, setTableData] = useState(companyData);
    const [selectedData, setSelectedData] = useState({year: new Date().getFullYear(), _id: ""});
    const [incrKey, setIncrKey] = useState(0);
    const [prefillCompany, setPrefillCompany] = useState(true);
    const [doubleClicked, setDoubleClicked] = useState(false);
    const [showPasswordsModal, setShowPasswordsModal] = useState(false);
    const companyNameAndYear = `${(!isEmpty(companyDetails.smallName) && companyDetails?.smallName !== "Small Company") ? companyDetails.smallName : company.name} - ${company.year}`;

    const selectCompanyRef = useRef(null);

    const emronCompanyInvalid = useSelector((state) => state.ACTIVITY.emronCompanyInvalid);
    const canBypassInvalidCompany = useSelector((state) => state.ACTIVITY.canBypassInvalidCompany);
    const emronCompanyInvalidDays = useSelector((state) => state.ACTIVITY.emronCompanyInvalidDays);
    const isEmronClient = useSelector((state) => state.ACTIVITY.isEmronClient);
    const emronClientData = useSelector((state) => state.ACTIVITY.emronClientData);

    const isTaxisScrapingActive = useSelector((state) => state.ACCOUNTING_DATA?.isTaxisScrapingActive) || false;
    const taxisScrapingMessage = useSelector((state) => state.ACCOUNTING_DATA?.taxisScrapingMessage) || "Σε εξέλιξη επικοινωνία με το Taxisnet. Παρακαλώ περιμένετε...";

    const [showEmronCompanyInvalidModal, setShowEmronCompanyInvalidModal] = useState(false);

    const upgradeEmployeeLimitModalData = useSelector((state) => state.PAYROLL.upgradeEmployeeLimitModalData);

    const isMobileScreen = useMediaQuery("(max-width: 980px)");

    const isEmron = useSelector((state) => state.ACTIVITY.isEmron);
    const [showEmronModal, setShowEmronModal] = useState(false);
    const [companyAccess, setCompanyAccess] = useState([]);
    const [companyAccessFilter, setCompanyAccessFilter] = useState([]);
    const [emronModalSelectedCompany, setEmronModalSelectedCompany] = useState({});
    const [emronModalSelectedCompanyDisplay, setEmronModalSelectedCompanyDisplay] = useState("");
    const [emronModalSelectedCompanyData, setEmronModalSelectedCompanyData] = useState({});

    const isEmronConnectFileERP = useSelector((state) => state.ACTIVITY.isEmronConnectFileERP);
    const primerMyDataToExpireModal = useSelector((state) => state.ACTIVITY.primerMyDataToExpireModal);
    const primerMyDataToExpireModalLink = useSelector((state) => state.ACTIVITY.primerMyDataToExpireModalLink);
    const primerMyDataExpirationModalMessage = useSelector((state) => state.ACTIVITY.primerMyDataExpirationModalMessage);

    const isDrawerOpen = useSelector((state) => state.ACTIVITY.showFooterDrawer);
    const footerRef = useRef(null);

    const showNewBankAgreementAttentionModal = useSelector((state) => state.ACCOUNTING_DATA.showNewBankAgreementAttentionModal);
    const showNewBankAgreementAttentionModalMessage = useSelector((state) => state.ACCOUNTING_DATA.showNewBankAgreementAttentionModalMessage);

    const slideBarToggle = useSelector((state) => isMobileScreen ? false : state.ACTIVITY.slideBarToggle);

    useEffect(() => {
        if (doubleClicked) {
            setDoubleClicked(false);
            handleSubmit();
        }
    }, [doubleClicked])

    useEffect(() => {
        if (show) {
            getCompanies(selectedData);
        }
    }, [show, selectedData.year])

    useEffect(() => {
        filterCompanies();
        setIncrKey(incrKey + 1);
    }, [companyFilterInput, companyData])

    useEffect(() => {
        if (emronCompanyInvalidDays > 0) {
            setShowEmronCompanyInvalidModal(true);
        }
    }, [emronCompanyInvalid, emronCompanyInvalidDays])

    useEffect(() => {
        if (prefillCompany) {
            const current = localStorage.getItem("company");
            if (current) {
                const companyObject = JSON.parse(current);
                if (companyObject) {
                    setSelectedData({year: companyObject.year, name: companyObject.name, _id: companyObject.id, vatNumber: companyObject.vatNumber});
                    setShowButton(true);
                    setPrefillCompany(false);
                }
            }
        }
    }, [prefillCompany])

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isTaxisScrapingActive) {
                e.preventDefault();
                e.returnValue = "Εκτελείται άντληση στοιχείων από το Taxisnet. Είστε σίγουροι ότι θέλετε να εγκαταλείψετε τη σελίδα;";
                return e.returnValue;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [isTaxisScrapingActive]);

    useEffect(() => {
        const handleGlobalExtensionScrapeEvents = (event) => {
            if (event.source !== window || !event.data) return;
            const { type } = event.data;

            if (type === "TO_ERP_POST_FILL_SCRAPING_STARTED") {
                dispatch(setTaxisScrapingState({
                    active: true,
                    message: "Σε εξέλιξη έλεγχος υποβολής και αυτόματη άντληση δήλωσης από το Taxisnet..."
                }));
            } else if (
                type === "TO_ERP_SCRAPE_VAT_RESPONSE" ||
                type === "TO_ERP_AUTOFILL_FAILED" ||
                type === "TO_ERP_TAXIS_WINDOW_CLOSED"
            ) {
                dispatch(setTaxisScrapingState({ active: false, message: "" }));
            }
        };

        window.addEventListener("message", handleGlobalExtensionScrapeEvents);
        return () => window.removeEventListener("message", handleGlobalExtensionScrapeEvents);
    }, [dispatch]);

    const handleFooterModalClose = () => {
        setCompanyFilterInput("");
        setTableData(companyData);
        setShow(false);
    }

    const handleFooterModalOpen = () => {
        if (isTaxisScrapingActive) {
            toast.warning("Δεν επιτρέπεται αλλαγή εταιρείας κατά τη διάρκεια άντλησης από το Taxisnet.", {
                autoClose: 5000
            });
            return;
        }
        setTableData([]);
        setShow(true);
    };

    const getCompanies = (selectedData) => {
        const user = JSON.parse(localStorage.getItem('user'));
        let uType = "user";
        if (user?.userType === "Admin") uType = "admin";
        /*
        // Token refresh code for future use
        axios.post(`${process.env.REACT_APP_LOGIN_BACKEND_URL}/api/public/refresh-login`, {
            userId: user._id
        }).then((res) => {
            if (res.status === 200) {
                localStorage.setItem("token", res.data.data.token);
                const user = getCurrentUser();
                user.token = res.data.data.token;
                localStorage.setItem("user", JSON.stringify(user));
                axios.post(`${process.env.REACT_APP_API_URL2}/public/refresh-login`, {
                    email: res.data.data.email,
                    deviceId: res.data.data.deviceId,
                }).then((res) => {
                    if (res.data.status === "200") {
                        toast.success("Επιτυχής ενέργεια.");
                    }
                }).catch((err) => {
                    console.log(err);
                })
            }
        }).catch((err) => {
            console.log(err);
        });
         */
        axios.get(`${process.env.REACT_APP_LOGIN_BACKEND_URL}/api/${uType}/company/list?year=${selectedData.year.toString()}`, {
            headers: {authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then((res) => {
            if (res.status === 200) {
                setCompanyData(res.data.data);
                setTableData(res.data.data);
                setTimeout(() => {
                    if (selectCompanyRef && selectCompanyRef?.current) {
                        selectCompanyRef.current?.scrollIntoView({
                            behavior: "instant",
                            block: "center",
                            inline: "start",
                            container: "nearest"
                        })
                    }
                }, 50)
            } else if (res.status === 401) {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=${errorAuth}`)
            }
        }).catch((err) => {
            if (err) {
                let message = 'Service is unavailable for the moment. Please try again later.'
                localStorage.clear();
                dispatch(logout());
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=${message}`);
            }
        })
    }

    const handleYearChange = (e) => {
        setSelectedData({...selectedData, year: e.value});
        const user = JSON.parse(localStorage.getItem('user'));
        let uType = "user";
        if (user?.userType === "Admin") uType = "admin";
        axios.get(process.env.REACT_APP_LOGIN_BACKEND_URL + `/api/${uType}/company/list?year=${e.value.toString()}`, {
            headers: {authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then((res) => {
            console.log(res.data);
            if (res.data.status === 200) {
                setCompanyData(res.data.data);
                if (res.data.data?.find((el) => el.vatNumber === selectedData.vatNumber) && !isEmpty(selectedData.vatNumber)) {
                    setSelectedData({...selectedData, year: e.value});
                }
            } else if (res.data.status === "401") {
                localStorage.clear();
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=${errorAuth}`)
            }
        }).catch((err) => {
            if (err) {
                let message = 'Service is unavailable for the moment. Please try again later.'
                localStorage.clear();
                dispatch(logout());
                window.location.replace(`${apiLoginURL}?redirect=ERP&error=${message}`);
            }
        })
    }

    const filterCompanies = () => {
        if (String(companyFilterInput).length > 0) {
            let filteredData = [];
            let value = companyFilterInput.toString().toLowerCase();
            const pattern = expandSearch(value);
            if (companyData)
                filteredData = companyData.filter((item) => {
                    let returnType = false;
                    for (const key in item) {
                        if (key === "name" || key === "vatNumber") {
                            let string = item[key];
                            if (pattern.test(string)) {
                                returnType = true;
                            }
                        }
                    }
                    return returnType;
                });
            setTableData(filteredData);
        } else {
            setTableData(companyData);
        }
    }

    const handleSubmit = () => {
        let erpURL = "";
        if (String(selectedData._id) === String(company.id) && String(selectedData.year) === String(company.year)) {
            handleFooterModalClose();
        } else if (selectedData._id) {
            let companyD = {
                id: selectedData._id,
                name: selectedData.name,
                vatNumber: selectedData.vatNumber,
                year: selectedData.year,
            };
            if (getCurrentUser().userType === "Admin") {
                dispatch(setCompany(companyD));
                localStorage.setItem("company", JSON.stringify(companyD));
                companyData.forEach((c) => {
                    c.years.forEach((y) => {
                        if (String(y.year) === String(selectedData.year) && selectedData._id === c._id) {
                            erpURL = y.erp_ip;
                        }
                    })
                });
                toast.success("Company Changed successfully.");
                handleFooterModalClose();
                dispatch(fetchPrimerMyDataCredentials(companyD.id));
                sessionStorage.setItem("company", JSON.stringify(selectedData));
                window.location.replace(`${erpURL}?token=${localStorage.getItem("token")}&company=${JSON.stringify(selectedData)}&device_id=${localStorage.getItem("deviceId")}&erp_ip=${erpURL}`);
            } else {
                axios.post(`${process.env.REACT_APP_LOGIN_BACKEND_URL}/api/public/company/check-company-expiration`, {
                    user: getCurrentUser()._id,
                    company: selectedData._id,
                    companyExpireDate: selectedData.companyExpireDate
                }).then(async (response) => {
                    if (response.data && response.data.success === true) {
                        if (selectedData._id) {
                            for (let i = 0; i < companyData.length; i++) {
                                if (companyData[i].years) {
                                    for (let y of companyData[i].years) {
                                        if ((y.year === selectedData.year || y.year === selectedData.year.toString()) && selectedData._id === companyData[i]._id) {
                                            erpURL = y.erp_ip;
                                        }
                                    }
                                }
                            }
                            dispatch(setCompany(companyD));
                            localStorage.setItem("company", JSON.stringify(companyD));
                            companyData.forEach((c) => {
                                c.years.forEach((y) => {
                                    if (String(y.year) === String(selectedData.year) && selectedData._id === c._id) {
                                        erpURL = y.erp_ip;
                                    }
                                })
                            });
                            toast.success("Επιτυχής αλλαγή εταιρείας.");
                            handleFooterModalClose();
                            dispatch(fetchPrimerMyDataCredentials(companyD.id));
                            sessionStorage.setItem("company", JSON.stringify(selectedData));
                            const escapedData = encodeURIComponent(JSON.stringify(selectedData));
                            window.location.replace(`${erpURL}?token=${localStorage.getItem("token")}&company=${escapedData}&device_id=${localStorage.getItem("deviceId")}&erp_ip=${erpURL}`);
                        } else {
                            toast.error("Παρακαλώ επιλέξτε εταιρεία");
                        }
                    } else {
                        handleFooterModalClose();
                        if (permissionsData.some((el) => el.permissionName === "custom-companyCreator")) {
                            toast.error("Η κύρια εταιρεία έχει λήξει!");
                        } else {
                            toast.error("Η εταιρεία έχει λήξει!");
                        }
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                })
            }
        }
    }

    const handleCompanySelection = (company, doubleClick = false) => {
        if (!doubleClick) {
            setShowButton(true);
            setSelectedData({...selectedData, ...company});
        } else {
            setShowButton(false);
            setSelectedData({...selectedData, ...company});
            setDoubleClicked(true);
        }
    }

    const handleEmronClientPayNow = () => {
        axios.post(process.env.REACT_APP_API_URL2 + "/emron/emron-pay-now-link", {
            company: company.id,
            vatNumber: company.vatNumber,
        }).then((res) => {
            if (res.data.status === "200") {
                window.open(res.data.linkURL, '_blank').focus();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const isSelected = (vatNumber) => {
        return vatNumber === selectedData.vatNumber;
    }

    const tdStyle = {
        padding: "7px",
        borderLeft: "1px solid lightgray",
        borderTop: "1px solid lightgray",
        borderRight: "1px solid lightgray",
        borderBottom: "1px solid black",
    }

    const showEmronPayNowButton = (emronCompanyInvalidDays > 0 && isEmronClient);

    const handleOpenCloudTab = () => {
        dispatch(openCloud(TABS_DATA));
    }

    useEffect(() => {
        if (isEmron) getCompanyAccess();
    }, [isEmron]);

    useEffect(() => {
        if (isEmron && !isEmpty(emronModalSelectedCompany.value) && !isEmpty(emronModalSelectedCompany.label)) {
            setEmronModalSelectedCompanyDisplay(emronModalSelectedCompany.label);
            axios.get(`${process.env.REACT_APP_API_URL2}/emron/get-client-data`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    selection: emronModalSelectedCompany.value,
                }
            }).then((res) => {
                if (res.data.status === "200") {
                    setEmronModalSelectedCompanyData(res.data.data);
                } else {
                    setEmronModalSelectedCompanyData({});
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.")
            })
        }
    }, [emronModalSelectedCompany])

    const getCompanyAccess = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-user-companies-access`, {
            headers: {"Content-Type": "application/json"},
            params: {
                userId: getCurrentUser()?._id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                let acc = [];
                for (let comp of res.data.data) {

                    acc.push({
                        label: `${comp.name} : ${comp.vatNumber}`,
                        value: comp._id, name: comp.name,
                        vatNumber: comp.vatNumber,
                        phone: comp.contactPoints ? `${comp.phone}${comp.contactPoints.map((el) => !isEmpty(el.mobile) ? `,${el.mobile}` : "")}` : comp.phone,
                        contactPoints: comp.contactPoints ? comp.contactPoints.map((el) => el.name)?.join(", ") : "",
                    });
                }
                setCompanyAccess(acc);
                setCompanyAccessFilter(acc);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const onChangeSearch = (keyword) => {
        setEmronModalSelectedCompanyDisplay(keyword);
        if (keyword.length >= 2) {
            keyword = escapeRegex(keyword);
            const regex = expandSearch(keyword);
            const filtered = companyAccess.filter((el) => (regex.test(el.name) || regex.test(el.vatNumber) || regex.test(el.phone) || regex.test(el.contactPoints ?? "")));
            setCompanyAccessFilter(filtered);
        } else {
            setCompanyAccessFilter(companyAccess);
        }
    }

    const handleOnClear = () => {
        setEmronModalSelectedCompanyDisplay("");
        setEmronModalSelectedCompany({...emronModalSelectedCompany, label: ""});
        setCompanyAccessFilter(companyAccess);
    }

    const companyColumns = [
        {
            label: "Όνομα",
            name: "name",
        }, {
            label: "Α.Φ.Μ.",
            name: "vatNumber",
        }, {
            label: "Τηλέφωνο",
            name: "phone",
        }, {
            label: "Επαφές",
            name: "contactPoints",
        }
    ];

    const [touchStartY, setTouchStartY] = useState(null);
    const [touchEndY, setTouchEndY] = useState(null);

    const handleTouchStart = (e) => {
        setTouchStartY(e.touches[0].clientY);
    }

    const handleTouchMove = (e) => {
        setTouchEndY(e.touches[0].clientY);
    }

    const handleTouchEnd = () => {
        if (touchStartY !== null && touchEndY !== null) {
            const deltaY = touchStartY - touchEndY;
            if (Math.abs(deltaY) > 50) {
                if (deltaY > 0) {
                    dispatch(setShowFooterDrawer(true));  // Swiped Up
                } else {
                    dispatch(setShowFooterDrawer(false)); // Swiped Down
                }
            }
        }
        setTouchStartY(null);
        setTouchEndY(null);
    }

    const handleGuideToBankAgreements = () => {
        dispatch(setShowNewBankAgreementAttentionModal(false));
        dispatch(openTabByType("search-bank-account", TABS_DATA));
    }

    const renderCallCenter = () => {
        if (checkPermission('custom-callcenter', permissionsData) === true && ["800566476", "801866110", "800434990"].includes(company.vatNumber)) {
            return (
                <React.Fragment>
                    <CallCenterLive permissionsData={permissionsData} />
                    {checkPermission("custom-sales", permissionsData) && (
                        <DialUp />
                    )}
                </React.Fragment>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    const renderFooterText = () => {
        if (isMobileScreen) {
            return (
                <span className="text-white mr-1 text-small" style={{ whiteSpace: 'nowrap' }}>© Primer Software {moment().format('YYYY')}</span>
            )
        } else {
            return (
                <span className="text-white ml-1">Primer ERP Copyright © Primer Software P.C. {moment().format('YYYY')} Version 3.0.0
                    {company.companyExpireDate && moment(company.companyExpireDate).diff(moment(), 'days') < 2 && moment().toDate() < moment(company.companyExpireDate).toDate() && (
                        <>
                            <br/>
                            <span className="text-danger">Η συνδρομή σας λήγει σε{' '}{moment(company.companyExpireDate).diff(moment(), 'days')} ημέρες. Παρακαλώ επικοινωνήστε με την Primer Software.</span>
                        </>
                    )}
                    {emronCompanyInvalidDays > 0 && (
                        <>
                            <br/>
                            <span className={!showEmronPayNowButton ? 'text-danger' : ''}>Η πληρωμή της μηνιαίας σας συνδρομής για τις λογιστικές υπηρεσίες του τρέχοντα μήνα απέτυχε.</span>
                        </>
                    )}
                </span>
            )
        }
    }

    const renderEmronButton = () => {
        if (checkPermission('custom-logistirio', permissionsData) === true && isEmron) {
            return (
                <Badge
                    bg="primary"
                    className="mr-2"
                    style={{ cursor: 'pointer', maxHeight: '36px', padding: 0 }}
                    onClick={() => setShowEmronModal(true)}
                >
                    <img
                        src={"assets/images/emron.png"}
                        style={{
                            height: '36px',
                            width: '36px',
                            backgroundColor: 'white',
                            borderRadius: '0.125rem',
                        }}
                        alt="Emron"
                    />
                </Badge>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    const renderCloudButton = () => {
        if (checkPermission('custom-cloud', permissionsData) === true) {
            return (
                <Badge
                    bg="primary"
                    className="mr-2 d-flex align-items-center"
                    style={{ cursor: 'pointer', maxHeight: '36px' }}
                    onClick={() => handleOpenCloudTab()}
                >
                    {isEmron && (
                        <span style={{ fontSize: '14px' }} className="mr-2">
                            PRIMER CONNECT
                        </span>
                    )}
                    <img src={"assets/images/cloud.png"} alt="Cloud" />
                </Badge>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    const renderEmronPasswordButton = () => {
        if (emronClientData && emronClientData?.emronPasswords?.length > 0 && checkPermission('custom-logistirio', permissionsData) === true) {
            return (
                <OverlayTrigger
                    key="passwords"
                    placement="top"
                    overlay={<Tooltip id={`tooltip-top`}>Κωδικοί Πελάτη</Tooltip>}
                >
                    <Badge
                        style={{
                            cursor: 'pointer',
                            position: 'relative',
                            borderRadius: '4px',
                            maxHeight: '36px',
                        }}
                        className="mr-2"
                        bg="primary"
                        onClick={() => setShowPasswordsModal(true)}
                    >
                        <img src={"assets/images/key.png"} alt="Key" />
                    </Badge>
                </OverlayTrigger>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    const renderSelectCompanyButton = () => {
        return (
            <Button
                className={`${showEmronPayNowButton ? 'payNowDangerButton' : ''}`}
                style={isMobileScreen ? { padding: '0' } : {}}
                variant="primary"
                size="sm"
                disabled={isTaxisScrapingActive}
                onClick={() => handleFooterModalOpen()}
            >
                {isMobileScreen ? (
                    <span style={{ fontSize: '10px' }}>{companyNameAndYear.length > 18 ? `${companyNameAndYear.slice(0, 15)}....` : companyNameAndYear}</span>
                ) : (
                    companyNameAndYear
                )}
            </Button>
        )
    }

    const renderEmronPayNowButton = () => {
        if (showEmronPayNowButton) {
            return (
                <Button
                    size="sm"
                    className="ml-3 payNowDangerButton"
                    onClick={() => handleEmronClientPayNow()}
                >
                    Πληρωμή τώρα
                </Button>
            )
        }
        return <React.Fragment></React.Fragment>
    }

    return (
        <div className="main-panel fixedPanel" style={slideBarToggle && !isMobileScreen ? {marginLeft: "3rem"} : {marginLeft: ""}}>
            {isTaxisScrapingActive && (
                <div
                    style={{
                        position: "fixed",
                        bottom: isMobileScreen ? "70px" : "60px",
                        right: "24px",
                        zIndex: 9999,
                        backgroundColor: "#0f172a",
                        color: "#f8fafc",
                        padding: "12px 18px",
                        borderRadius: "10px",
                        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.45), 0 0 0 1px #334155",
                        borderLeft: "4px solid #76aeb7",
                        maxWidth: "380px",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        pointerEvents: "auto",
                        animation: "fadeIn 0.25s ease-in-out"
                    }}
                >
                    <div style={{ flexShrink: 0, marginTop: "2px" }}>
                        <Spinner animation="border" size="sm" style={{ color: "#76aeb7", borderWidth: "2px" }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="font-weight-bold text-white mb-1" style={{ fontSize: "0.85rem", letterSpacing: "0.2px" }}>
                            Taxis Bridge σε εξέλιξη
                        </div>
                        <div className="text-light mb-1" style={{ fontSize: "0.78rem", lineHeight: "1.35", color: "#cbd5e1" }}>
                            {taxisScrapingMessage}
                        </div>
                        <div style={{ fontSize: "0.7rem", fontWeight: "600" }}>
                            Μην κλείνετε ή ανανεώνετε τη σελίδα
                        </div>
                    </div>
                </div>
            )}
            {(emronCompanyInvalid && emronCompanyInvalidDays > 40 && !canBypassInvalidCompany) && (
                <div hidden={!emronCompanyInvalid} style={{paddingLeft: "20px", paddingTop: "20px"}}>
                    Η παρούσα εταιρεία δεν είναι προσβάσιμη επειδή έχει λήξει η μηνιαία χρέωση του πελάτη.
                </div>
            )}
            <div
                className="content-wrapper"
                key={"view-wrapper-static"}
                hidden={emronCompanyInvalid && emronCompanyInvalidDays > 40 && !canBypassInvalidCompany}
                style={{marginTop: isMobileScreen ? "35px" : "", padding: "3.50rem 0.5rem 4.75rem 0.5rem"}}
            >
                <Tabs permissionsData={permissionsData} />
            </div>

            <Modal className="themeModal" show={show} onHide={() => handleFooterModalClose()}
                   dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('CompanyTable.selectCompanyAndYear')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="pb-3">
                        <Col md={9}>
                            <Input
                                type="text"
                                name="search"
                                label={"Αναζήτηση"}
                                autoComplete={"off"}
                                placeholder={t('CompanyTable.placeholder')}
                                onChange={(e) => setCompanyFilterInput(e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                label={"Έτος"}
                                defaultValue={{
                                    label: selectedData.year,
                                    value: selectedData.year,
                                }}
                                options={companyYearOptions()}
                                classes="w-100"
                                onChange={(e) => handleYearChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{maxHeight: "55vh", overflowY: "auto"}}>
                                <table style={{width: "100%"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "80%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                    </colgroup>
                                    <thead style={{textAlign: "center", backgroundColor: "var(--light-skyblue)", position: "sticky", top: "-1px"}}>
                                    <tr>
                                        <th style={tdStyle}>{t('CompanyTable.company')}</th>
                                        <th style={tdStyle}>{t("General.vatNumber")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tableData?.length > 0 ? (
                                        <React.Fragment>
                                            {tableData.map((company, idx) => (
                                                <tr key={`companyModalTable-${idx}`}
                                                    onClick={() => handleCompanySelection(company, false)}
                                                    onDoubleClick={() => handleCompanySelection(company, true)}
                                                    style={{backgroundColor: isSelected(company.vatNumber) ? "var(--light-skyblue)" : "", border: isSelected(company.vatNumber) ? "2px solid black" : ""}}
                                                    ref={isSelected(company.vatNumber) ? selectCompanyRef : null}>
                                                    <td style={tdStyle}>
                                                        {company.name}
                                                        {company?.masterAccountants && (
                                                            <div className={"text-muted font-italic"}>
                                                                Υπεύθυνος λογιστής: {company?.masterAccountants}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{
                                                        ...tdStyle,
                                                        textAlign: "center"
                                                    }}>{company.vatNumber}</td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ) : (
                                        <tr>
                                            <td colSpan={2}>Δεν βρέθηκαν δεδομένα.</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {showButton === true &&
                        <Button variant="primary" onClick={() => handleSubmit()}>{t('CompanyTable.select')}</Button>
                    }
                </Modal.Footer>
            </Modal>

            <Modal show={showEmronCompanyInvalidModal} backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title>Ενημέρωση</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(emronCompanyInvalidDays > 0 && emronCompanyInvalidDays <= 40) && (
                        <React.Fragment>
                            {isEmronClient ? (
                                <React.Fragment>
                                    {emronCompanyInvalidDays === 38 ? (
                                        <span>
                                            Υπενθυμίζουμε ότι η μηνιαία σας συνδρομή για τις λογιστικές υπηρεσίες παραμένει ανεξόφλητη και σε 48 ώρες θα λήξει οριστικά,
                                            διακόπτοντας την πρόσβαση του λογιστηρίου στην εταιρεία σας
                                            (δεν θα μπορούν να αποσταλούν οι μηνιαίες φορολογικές σας υποχρεώσεις (π.χ. ΦΠΑ, μισθοδοσία, κ.λ.π.).
                                            Παρακαλούμε φροντίστε άμεσα για την εξόφληση, κάνοντας χρήση του παρακάτω συνδέσμου (Πληρωμή Τώρα).
                                        </span>
                                    ) : (emronCompanyInvalidDays === 39 || emronCompanyInvalidDays === 40) ? (
                                        <span>
                                            Υπενθυμίζουμε ότι η μηνιαία σας συνδρομή για τις λογιστικές υπηρεσίες παραμένει ανεξόφλητη και σε 24 ώρες θα λήξει οριστικά,
                                            διακόπτοντας την πρόσβαση του λογιστηρίου στην εταιρεία σας
                                            (δεν θα μπορούν να αποσταλούν οι μηνιαίες φορολογικές σας υποχρεώσεις (π.χ. ΦΠΑ, μισθοδοσία, κ.λ.π.).
                                            Παρακαλούμε φροντίστε άμεσα για την εξόφληση, κάνοντας χρήση του παρακάτω συνδέσμου (Πληρωμή Τώρα).
                                        </span>
                                    ) : (
                                        <span>
                                            Η πληρωμή της μηνιαίας σας συνδρομής για τις λογιστικές υπηρεσίες του τρέχοντα μήνα απέτυχε.
                                            Παρακαλούμε για την άμεση εξόφληση κάνοντας χρήση της επιλογής "Πληρωμή Τώρα" ώστε να εξασφαλιστεί η απρόσκοπτη παροχή των λογιστικών υπηρεσιών.
                                        </span>
                                    )}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    Η ανανέωση της μηνιαίας συνδρομής λογιστικών υπηρεσιών του πελάτη απέτυχε, λόγω μη εξόφλησης.
                                    Παρακαλούμε επικοινωνήστε μαζί του ώστε να φροντίσει για την τακτοποίησή της.
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                    {emronCompanyInvalidDays > 40 && (
                        <React.Fragment>
                            {isEmronClient ? (
                                <React.Fragment>
                                    Η μηνιαία συνδρομή σας για τις λογιστικές υπηρεσίες έχει λήξει οριστικά λόγω ανεξόφλητου υπολοίπου και η πρόσβαση του λογιστηρίου στην εταιρεία σας έχει διακοπεί.
                                    Το λογιστήριο δεν μπορεί να αποστείλει τις μηνιαίες φορολογικές υποχρεώσεις
                                    σας (π.χ. ΦΠΑ, μισθοδοσία, κ.λ.π.). Παρακαλούμε φροντίστε άμεσα για την εξόφληση, κάνοντας χρήση του παρακάτω συνδέσμου (Πληρωμή Τώρα),
                                    ώστε να γίνει ενεργοποίηση της συνδρομής σας.
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {!canBypassInvalidCompany ? (
                                        <React.Fragment>
                                            Η πρόσβασή σας έχει διακοπεί στην παρούσα εταιρεία, καθώς η συνδρομή του πελάτη έχει λήξει λόγω μη εξόφλησης.
                                            Παρακαλούμε επικοινωνήστε μαζί του ώστε να φροντίσει άμεσα για την τακτοποίησή της.
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            Η ανανέωση της μηνιαίας συνδρομής λογιστικών υπηρεσιών του πελάτη απέτυχε, λόγω μη εξόφλησης.
                                            Παρακαλούμε επικοινωνήστε μαζί του ώστε να φροντίσει για την τακτοποίησή της.
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowEmronCompanyInvalidModal(false)}>
                        Εντάξει
                    </Button>
                    {isEmronClient && (
                        <Button variant={"outline-primary"} onClick={() => handleEmronClientPayNow()}>
                            Πληρωμή τώρα
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {emronClientData && (
                <Modal show={showPasswordsModal} onHide={() => setShowPasswordsModal(false)} dialogClassName={"modal42PercentWidth"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Κωδικοί Πελάτη</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {emronClientData?.emronPasswords?.length > 0 ? (
                            <div>
                                <table className={"simpleClassicTable"}>
                                    <colgroup>
                                        <col span={1} style={{width: "10%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "20%"}}></col>
                                        <col span={1} style={{width: "30%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>Αρ.</th>
                                        <th>Τύπος</th>
                                        <th>Όνομα Χρήστη</th>
                                        <th>Κωδικός</th>
                                        <th>Σημειώσεις</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {emronClientData?.emronPasswords.map((row, idx) => (
                                        <tr key={`table-eP${idx}`} style={{wordBreak: "break-all"}}>
                                            <td>{row["no"]}</td>
                                            <td>{row["type"]}</td>
                                            <td>{row["username"]}</td>
                                            <td>{row["password"]}</td>
                                            <td>{row["notes"]}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div>
                                Δεν βρέθηκαν κωδικοί πελάτη
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={() => setShowPasswordsModal(false)}>
                            Κλείσιμο
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            <Modal show={upgradeEmployeeLimitModalData.show} backdrop={"static"} style={{zIndex: 2000}}>
                <Modal.Header>
                    <Modal.Title>Αναβάθμιση πακέτου</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {upgradeEmployeeLimitModalData.text}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => dispatch(setUpgradeEmployeeLimitModalData({show: false, text: "", buttonURL: ""}))}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => {
                        window.open(upgradeEmployeeLimitModalData.buttonURL, "_blank");
                        dispatch(setUpgradeEmployeeLimitModalData({show: false, text: "", buttonURL: ""}));
                    }}>
                        Αναβάθμιση
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showEmronModal} onHide={() => setShowEmronModal(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αναζήτηση πελάτη</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={5}>
                            <AdvancedCombobox
                                className="w-200 ac-select-dropdown"
                                inputFieldClasses="form-control"
                                defaultValue={emronModalSelectedCompanyDisplay}
                                onChange={(e) => setEmronModalSelectedCompany(e.row)}
                                onChangeSearch={onChangeSearch}
                                columns={companyColumns}
                                excludeColumns={[]}
                                showTableOptionOnSelect={true}
                                deleteEnable={false}
                                searchTableEnable={false}
                                label={"Εταιρείες"}
                                placeholder={"Επιλέξτε εταιρεία"}
                                data={companyAccessFilter}
                                resetFilter={handleOnClear}
                            />
                        </Col>
                    </Row>
                    {Object.keys(emronModalSelectedCompanyData).length > 0 && (
                        <Row>
                            <Col md={12}>
                                <EmronClientData
                                    clientData={emronModalSelectedCompanyData}
                                />
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={primerMyDataToExpireModal} backdrop={"static"}>
                <Modal.Header>
                    <Modal.Title>Απαιτείται Προσοχή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {primerMyDataExpirationModalMessage}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={"outline-primary"} onClick={() => dispatch(setShowPrimerMyDataToExpireModal(false))}>
                        Εντάξει, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => window.open(primerMyDataToExpireModalLink, "_blank")}>
                        Πληρωμή τώρα
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showNewBankAgreementAttentionModal} backdrop={"static"} onHide={() => dispatch(setShowNewBankAgreementAttentionModal(false))} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Απαιτείται Προσοχή!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{__html: showNewBankAgreementAttentionModalMessage}}></div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => handleGuideToBankAgreements()}>
                        Μετάβαση
                    </Button>
                </Modal.Footer>
            </Modal>

            <DrugInfoModal />
            <ReleaseNotesModal />

            {/* Footer */}
            {isMobileScreen && (
                <div
                    onClick={() => dispatch(setShowFooterDrawer(!isDrawerOpen))}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    style={{
                        position: 'fixed',
                        transition: 'bottom 0.3s ease-in-out',
                        bottom: isDrawerOpen ? footerRef?.current?.getBoundingClientRect()?.height : '0px',
                        left: 0,
                        right: 0,
                        textAlign: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        padding: '0px',
                        zIndex: 9999,
                        color: 'white',
                        cursor: 'pointer',
                    }}
                >
                    {isDrawerOpen ? <FaChevronDown color={'#76aeb7'} size={15} /> : <FaChevronUp color={'#76aeb7'} size={15} />}
                </div>
            )}

            <footer
                ref={footerRef}
                className={`footer d-flex responsive-footer hide-scrollbar`}
                style={{
                    position: 'fixed',
                    display: "flex",
                    bottom: isMobileScreen ? (isDrawerOpen ? '0' : '-300px') : '0',
                    transition: 'bottom 0.3s ease-in-out',
                    width: '100%',
                    alignItems: 'center',
                    backgroundColor: showEmronPayNowButton ? '#76aeb7' : '',
                    color: showEmronPayNowButton ? 'white' : '',
                    maxHeight: 'fit-content',
                    zoom: isMobileScreen ? "0.8" : "1",
                    pointerEvents: isEmronConnectFileERP ? 'none' : '',
                    overflowX: 'visible',
                    paddingLeft: slideBarToggle ? "4.5rem" : ""
                }}
            >
                {renderCallCenter()}
                {renderFooterText()}
                {renderEmronPayNowButton()}

                {!permissionsData?.some(
                    (el) =>
                        el.permissionName === 'custom-epay' ||
                        el.permissionName === 'custom-peiraios' ||
                        el.permissionName === 'custom-daras' ||
                        el.permissionName === 'custom-cardlink'
                ) && (
                    <div
                        style={{
                            marginLeft: 'auto',
                            display: 'inline-flex',
                            marginTop: isMobileScreen ? '10px' : '0px',
                        }}
                    >
                        {renderEmronButton()}
                        {renderCloudButton()}
                        {renderEmronPasswordButton()}
                        {renderSelectCompanyButton()}
                    </div>
                )}
            </footer>
        </div>
    )
}

export default ViewWrapper;
